<div class="p-3">
    <div class="grid">
        <div class="col-12">
            <p-button icon="pi pi-arrow-left" label="Back" styleClass="p-button-primary" class="flex justify-content-center" (onClick)="goToCategories()"></p-button>
        </div>
        <div class="col-12 text-center">
            <h3 class="m-0">{{category?.instrumentTypeDisplayString}}</h3>
        </div>
    </div>
</div>

<div *ngFor="let group of category?.groupedInstruments">
    <div class="grid formgrid pt-2">
        <div class="col-12 text-bold">
            {{group[0].currentRunStateText}}
        </div>
        <div class="col-12">
            <hr>
        </div>
        <div class="col-12">
            <p-table [value]="group">
                <ng-template pTemplate="body" let-instrument>
                    <tr (click)="openInstrumentDetail(instrument)" [ngClass]="instrument.cellBackgroundColor">
                        <td class="">
                            <div class="grid formgrid">
                                <div class="col-8">
                                    <div class="col-12">
                                        {{instrument.friendlyInstrumentName}}
                                    </div>
                                    <div class="col-12">
                                        {{instrument.currentPlateText}}
                                    </div>
                                </div>
                                <div class="col-3 text-right">
                                    <div class="grid formgrid text-right h-full">
                                        <div *ngFor="let plate of instrument.queuedPlates" class="w-2">
                                            <i class="pi pi-circle-fill"></i>
                                        </div>
                                        <div class="col-12">
                                            {{instrument.currentPlateEstimatedTimeRemainingText}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-1">
                                    <div class="h-full">
                                        <i class="pi pi-chevron-right"></i>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>